module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "editor-box",
    on: {
      "click": function($event) {
        $emit('click')
      }
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!editorState.tabs.length),
      expression: "!editorState.tabs.length"
    }],
    staticClass: "editor-placeholder"
  }, ["\n    Choose a file from workspace or ", _h('a', {
    attrs: {
      "id": "cover-open"
    },
    on: {
      "click": openNewFile
    }
  }, ["create a new file"])]), " ", _h('div', {
    staticClass: "tab-bar"
  }, [(editorState.compilee) ? _h('div', {
    staticClass: "tab-bar-cover"
  }, [_h('span', {
    attrs: {
      "id": "compiling-filename"
    }
  }, [_s(editorState.compilee.fileName)])]) : _e(), " ", _h('button', {
    staticClass: "tab-new",
    on: {
      "click": openNewFile
    }
  }, ["+"]), " ", _h('div', {
    staticClass: "tab-row"
  }, [_h('div', {
    staticClass: "tab-group"
  }, [_l((editorState.tabs), function(tab) {
    return _h('div', {
      staticClass: "tab-cell",
      class: {
        active: currentTab == tab
      },
      on: {
        "click": function($event) {
          switchTab(tab)
        }
      }
    }, [_h('a', [_h('span', [_s(tab.file.fileName)]), " ", _h('span', {
      staticClass: "tab-dismiss",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          closeTab(tab)
        }
      }
    }, ["×"])])])
  })])])]), " ", _h('div', {
    staticClass: "editor-container"
  }, [_h('textarea', {
    ref: "textarea",
    attrs: {
      "id": "editor"
    }
  })])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-36860c63!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
 ** module id = 130
 ** module chunks = 2
 **/